import {
	createFileRoute,
	Outlet,
	redirect,
	useParams,
	useRouteContext,
} from "@tanstack/react-router";
import { fetchQuery, graphql, useLazyLoadQuery } from "react-relay";
import type { routeSpaceQuery } from "./__generated__/routeSpaceQuery.graphql";
import { SpacePaywall } from "@/ui/space-paywall";
import type { routeCommunityEnabledQuery } from "./__generated__/routeCommunityEnabledQuery.graphql";
import { environment } from "@/relay/environment";

export const Route = createFileRoute(
	"/_visibility/_topnav/comunidade/s/$space",
)({
	component: RouteComponent,
	loader: async ({ context }) => {
		const { club } = context;

		const data = await fetchQuery<routeCommunityEnabledQuery>(
			environment,
			graphql`
		    query routeCommunityEnabledQuery($slug: String!) {
		      club(slug: $slug) {
				    configuration(key: "COMMUNITY_ENABLED")
			    }
		    }
	`,
			{ slug: club.slug },
		).toPromise();

		if (data?.club.configuration?.length && data?.club.configuration !== "1") {
			throw redirect({
				to: "/",
			});
		}
	},
});

function RouteComponent() {
	const { club } = useRouteContext({ from: "__root__" });
	const { space } = useParams({
		from: "/_visibility/_topnav/comunidade/s/$space",
	});

	const data = useLazyLoadQuery<routeSpaceQuery>(
		graphql`
    query routeSpaceQuery($club: String!, $space: String!) {
      club(slug: $club) {
        space(slug: $space) {
          id
          name
          visibility
          isMember
          ...spacePaywall_space
        }
      }
    }
  `,
		{ club: club.slug, space },
	);

	if (
		!club.permissions.length &&
		!data.club.space.isMember &&
		(data.club.space.visibility === "PRIVATE" ||
			data.club.space.visibility === "SECRET")
	) {
		return <SpacePaywall space={data.club.space} />;
	}

	return <Outlet />;
}
